module.exports = __webpack_public_path__ + "static/media/icon-dashboard.a65f43c6.svg";